import { useCallback, useMemo, useState } from 'react'
import SummaryDashboard from '../../components/snoop/SummaryDashboard'
import { fetchOperationsUpdates } from '../../api/operationsClient'
import { PLACEHOLDER_OPS_UPDATES } from '../../utils/snoop/placeholderColumns'

const selectClass =
  'rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-800 shadow-sm focus:border-gray-400 focus:outline-none'

export default function OpsUpdatesPage() {
  const [dashboard, setDashboard] = useState('')
  const [options, setOptions] = useState([])

  const fetchData = useCallback(async () => {
    const data = await fetchOperationsUpdates({ dashboard: dashboard || undefined })
    const next = data?.filters?.dashboard_options
    if (Array.isArray(next)) setOptions(next)
    return data
  }, [dashboard])

  const defaultSort = useMemo(
    () => [{ column: 'Timestamp', direction: 'desc' }],
    [],
  )

  const extraActions = (
    <label className="inline-flex items-center gap-2 text-sm text-gray-600">
      Dashboard
      <select
        className={selectClass}
        value={dashboard}
        onChange={(e) => setDashboard(e.target.value)}
      >
        <option value="">All</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </label>
  )

  return (
    <SummaryDashboard
      title="Updates"
      subtitle="Audit feed of Operations edits, newest first"
      fetchData={fetchData}
      defaultSort={defaultSort}
      searchPlaceholder="Search user, action, artist, title…"
      extraActions={extraActions}
      layout="mapping"
      wrapColumns={['Detail']}
      truncateColumns={['Entity', 'Title']}
      placeholderColumns={PLACEHOLDER_OPS_UPDATES}
      tableKey={`ops-updates-${dashboard || 'all'}`}
    />
  )
}
